<template>
  <div class="housing-dashboard">
    <div class="housing-list pl-4 pt-4 pr-2">
      <widget headerText="Hébergements en cours">
        <rotate-square2 v-if="isLoading"></rotate-square2>
        <b-table
          v-else
          striped
          hover
          :items="housings"
          :fields="fields"
          @row-clicked="handleRowClick"
          :tbody-tr-class="housingClass"
          :sort-by="filter.sortBy"
          :sort-desc="filter.sortDesc"
          @sort-changed="sortChanged"
        ></b-table>
        <div class="pagination d-flex justify-content-end">
          <nav aria-label="...">
            <ul class="pagination">
              <li class="page-item" v-if="page > 0">
                <span 
                  class="page-link"
                  href="#"
                  v-on:click="
                    () => {
                      page -= 1;
                    }
                  "
                  >Précédent</span
                >
              </li>
              <li class="page-item" v-if="page > 0">
                <span
                  class="page-link"
                  href="#"
                  v-on:click="
                    () => {
                      page -= 1;
                    }
                  "
                  >{{ page }}</span
                >
              </li>
              <li class="page-item active">
                <span class="page-link" href="#"
                  >{{ page + 1 }} <span class="sr-only">(current)</span></span
                >
              </li>
              <li class="page-item" v-if="hasMorePages">
                <span
                  class="page-link"
                  href="#"
                  v-on:click="
                    () => {
                      page += 1;
                    }
                  "
                  >{{ page + 2 }}</span
                >
              </li>
              <li class="page-item" v-if="hasMorePages">
                <span
                  class="page-link"
                  href="#"
                  v-on:click="
                    () => {
                      page += 1;
                    }
                  "
                  >Suivant</span
                >
              </li>
            </ul>
          </nav>
        </div>
      </widget>
    </div>
  </div>
</template>

<script>
import Widget from "../../components/widgets/Widget";
import axios from "axios";
import { mapState } from "vuex";
import { RotateSquare2 } from "vue-loading-spinner";
export default {
  name: "housing-dashboard",
  components: { Widget, RotateSquare2 },
  props: {
    user: {
      required: false,
      type: Object,
    },
    antenna: {
      required: false,
      type: Object,
    },
  },
  data() {
    return {
      housings: [],
      users: [],
      page: 0,
      pages: 1,
      per_page: 10,
      filter: {
        sortBy: "start_date",
        sortDesc: true,
        user_id: null,
      },
      isLoading: false,
    };
  },
  computed: {
    ...mapState(["user", "antennas"]),
    hasMorePages() {
      return this.page + 1 < this.pages;
    },
    fields() {
      return [
        {
          key: "recipient.surname",
          label: "Prénom",
          sortable: true,
        },
        {
          key: "recipient.name",
          label: "Nom",
          sortable: true,
        },
        {
          key: "user",
          label: "Référent MRS",
          formatter: (val) =>
            val
              ? val.surname + " " + (val.name ? val.name.toUpperCase() : "")
              : "",
          sortable: true,
        },
        {
          key: "start_date",
          label: "Du",
          sortable: true,
          formatter: (val) =>
            val ? this.$moment(val).format("DD/MM/YYYY") : "",
        },
        {
          key: "end_date",
          label: "Au",
          sortable: true,
          formatter: (val) =>
            val ? this.$moment(val).format("DD/MM/YYYY") : "",
        },
        {
          key: "free_end_date",
          label: "Libérée le",
          sortable: true,
          formatter: (val) =>
            val ? this.$moment(val).format("DD/MM/YYYY") : "",
        },
        {
          key: "solde",
          label: "Solde",
          formatter: (val) => val + " €",
          tdClass: (value) => (value < 0 ? "table-warning" : ""),
        },
      ];
    },
  },
  mounted() {
    this.refreshHousingList();
    this.refreshLists();
  },
  watch: {
    page() {
      this.refreshHousingList();
    },
    user() {
      this.refreshHousingList();
    },
  },
  methods: {
    sortChanged(e) {
      this.filter.sortBy = e.sortBy;
      this.filter.sortDesc = e.sortDesc;
      this.refreshHousingList();
    },
    housingClass(housing, type) {
      if (type == "row") {
        if (
          this.$moment(housing.end_date) - this.$moment() < 0 &&
          (housing.free_end_date == "" || housing.free_end_date == undefined)
        ) {
          return "table-danger";
        } else if (
          this.$moment(housing.end_date) - this.$moment() > 0 &&
          this.$moment(housing.start_date) - this.$moment() <= 0
        ) {
          return "table-success";
        }
      } else {
        return;
      }
    },
    refreshLists() {
      if (
        this.user.habilitation == "volunteer" ||
        this.user.habilitation == "antenna_admin"
      ) {
        axios
          .get(`/api/web/users/antenna/${this.user.antenna_id}`)
          .then((res) => {
            this.users = res.data.data;
          });
      } else {
        axios.get(`/api/web/users`).then((res) => {
          this.users = res.data.data;
        });
      }
    },
    refreshHousingList() {
      this.isLoading = true;
      if (this.user) {
        this.filter.user_id = this.user._id;
      }
      axios
        .get("/api/web/housings/dashboard", {
          params: {
            filter: this.filter,
            page: this.page,
            per_page: this.per_page,
          },
        })
        .then((res) => {
          this.pages = res.data.pagination.last_page + 1;
          this.housings = res.data.data.map((h) => {
            h.nights = this.$moment(h.end_date).diff(
              this.$moment(h.start_date),
              "days"
            );
            h.total_price = h.price * h.nights;
            h.total_payment = h.payments.reduce((a, b) => a + b.amount, 0);
            h.solde = h.total_payment - h.total_price;
            return h;
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    handleRowClick(item) {
      this.$router.push(`/recipient/${item.recipient_id}#housing`);
    },
  },
};
</script>